import type { PeriodKey, SeriesFilter } from './types';

export const PERIODS: { key: PeriodKey; label: string; priorLabel: string }[] = [
    { key: 'week', label: 'Week', priorLabel: 'previous week' },
    { key: 'month', label: 'Month', priorLabel: 'previous month' },
    { key: 'all_time', label: 'Global', priorLabel: 'previous 12 months' },
];

export const SERIES_OPTIONS: { key: SeriesFilter; label: string }[] = [
    { key: 'both', label: 'Quotes' },
    { key: 'generated', label: 'Generated' },
    { key: 'converted', label: 'Converted' },
    { key: 'leads', label: 'Leads' },
];

export const LABEL_COLOR = '#6B7280';
export const PRIMARY = '#3B82F6';
export const PRIMARY_DARK = '#2563EB';
export const COLOR_GENERATED = '#F59E0B';
export const COLOR_CONVERTED = '#10B981';
export const COLOR_LEADS = '#0EA5E9';
export const COLOR_PENDING = '#8B5CF6';
export const COLOR_QUOTING_SLOPED = '#0EA5E9';
export const COLOR_QUOTING_FLAT = '#64748B';
export const COLOR_QUOTING_MIXED = '#F97316';
export const GRID_COLOR = '#E5E7EB';
export const CARD_SHADOW = '0 4px 12px rgba(0,0,0,0.05)';
export const CARD_SHADOW_HOVER = '0 8px 20px rgba(0,0,0,0.08)';

export const softCardSx = {
    borderRadius: '16px',
    boxShadow: CARD_SHADOW,
    border: 'none',
    bgcolor: '#fff',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: CARD_SHADOW_HOVER,
    },
};

export const chartFadeSx = {
    '@keyframes dashboardChartFadeIn': {
        from: { opacity: 0, transform: 'translateY(6px)' },
        to: { opacity: 1, transform: 'translateY(0)' },
    },
    animation: 'dashboardChartFadeIn 0.45s ease-out',
};

export const chartTheme = {
    text: { fill: LABEL_COLOR, fontSize: 12 },
    axis: {
        ticks: { text: { fill: LABEL_COLOR } },
        legend: { text: { fill: LABEL_COLOR, fontSize: 12 } },
    },
    grid: { line: { stroke: GRID_COLOR, strokeWidth: 1 } },
    crosshair: { line: { stroke: LABEL_COLOR, strokeWidth: 1, strokeOpacity: 0.35 } },
    tooltip: {
        container: {
            background: '#fff',
            color: '#111827',
            fontSize: 12,
            borderRadius: 10,
            boxShadow: CARD_SHADOW_HOVER,
            padding: '8px 12px',
        },
    },
};
